import { render, staticRenderFns } from "./ConsiderResult.vue?vue&type=template&id=9ff8b4b6&"
import script from "./ConsiderResult.vue?vue&type=script&lang=js&"
export * from "./ConsiderResult.vue?vue&type=script&lang=js&"
import style0 from "./ConsiderResult.vue?vue&type=style&index=0&id=9ff8b4b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports